<script>
//import axios from 'axios';
import api from '@/helpers/api-rest/api.js';

export default {
  props: {
    showUserModal: Boolean,
    user: {type: Object, default: () => {
        return {
            name: '',
            email: '',
            password: '',
            role_ids: [],
        }
    }} 
  },
  data() {
    return {
      selectedRoles: [],
    };
  },
  computed: {
    modalTitle() {
      return this.user?.id ? 'Edit User' : 'Add User';
    },
    submitButtonText() {
        return this.user?.id ? 'Save' : 'Add user';
    }
  },
  created() {
    this.loadSelectRole();
  },
  
  methods: {
    createUser() {
      //const apiHost = process.env.VUE_APP_API_HOST;
      const apiEndpoint = `/api/v1/users`; 
      api.post({url:apiEndpoint, data:this.user})
      //axios.post(apiEndpoint, this.user)
        .then(response => {
          const newUser = response.data;
          this.$emit('success', newUser);
          this.$bvModal.hide("ModalUser");
        })
        .catch(error => {
          console.error("Error al crear el usuario:", error);
        });
    },

    updateUser() {
        //const apiHost = process.env.VUE_APP_API_HOST;
        const apiEndpoint = `/api/v1/users`;

        api.put({url:apiEndpoint, data:this.user, id:this.user.id})
        //axios.put(apiEndpoint, this.user)
        .then(response => {
            const updatedUser = response.data;
            this.$emit('success', updatedUser);
            this.$bvModal.hide("ModalUser");
        })
        .catch(error => {
            console.error("Error editing user:", error);
        });
    },

    loadSelectRole() {
      const apiEndpoint = `/api/v1/roles`;
      api.get({url:apiEndpoint, params:{
        'status': 1,
      }})
        .then(response => {
          //console.log(response);
          this.selectedRoles = response.data;
        })
        .catch(error => {
          console.error("Error al cargar los roles:", error);
        });
    },

    submitForm() {
        //console.log(this.user);
        
        if(this.user?.id){
            return this.updateUser();
        }

        return this.createUser();
    },
    cancelForm() {
        this.$bvModal.hide("ModalUser");
        this.$emit('close-modal');
    }
  }
};
</script>


<template>
  
    <b-modal id="ModalUser" :title="modalTitle">  
      <template #default="{  }">
        <form @submit.prevent="submitForm">
            <div class="form-group">
                <label for="name">Name:</label>
                <input v-model="user.name" type="text" class="form-control" id="name" required>
            </div>
            <div class="form-group">
                <label for="email">Email:</label>
                <input v-model="user.email" type="email" class="form-control" id="email" required>
            </div>
            <div class="form-group">
                <label for="password">Password:</label>
                <input v-model="user.password" type="password" class="form-control" id="password" required>
            </div>
            <div class="form-group">
              <label for="role_ids">Roles:</label>
              <select v-model="user.role_ids" class="form-control" id="role_ids" multiple>
                <option v-for="option in selectedRoles" :value="option.id" :key="option.id">{{ option.name }}</option>
              </select>
            </div>
        </form>
      </template>
  
      <template #modal-footer="{  }">
        <b-button variant="primary" @click="submitForm()">{{ submitButtonText }}</b-button>
        <b-button @click="cancelForm()">Cancel</b-button>
      </template>
    </b-modal>
  </template>